import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Divider} from 'views/components';
import {Author} from 'views/module';

import {translate} from 'views/module';

import {UPDATE_TYPES} from './updates/index';

import displayResource from 'utils/miscellaneous/display_resource';
import moment from 'moment';

const LogFeedBox = (props) => {
  const [mouseOver, setMouseOver] = React.useState(false);

  const {
    log,
  } = props;

  const logMessage = UPDATE_TYPES[log.updateType];
  if (!logMessage) {
    // don't return anything if a log message doesn't exist for that update type
    return null;
  };

  const submittedBy = log.requester;

  const author = displayResource(submittedBy);

  const timestampInfoCalculator = () => {
    const createdAt = log.createdAt;

    const timestampPrefixLabel = translate(logMessage.title);

    const formattedTimestamp = moment(createdAt).format(translate('timeFormat.VerboseDay'));

    return `${timestampPrefixLabel} ${formattedTimestamp}`;
  };

  const Component = logMessage.component;

  return (
    <>
      <Box
        onMouseOver={(_) => setMouseOver(true)}
        onMouseLeave={(_) => setMouseOver(false)}
      >
        <Stack >
          <Divider />
          <Box
            p={{md: 2, xs: 1}}
            sx={{
              backgroundColor: mouseOver ? 'background.highlighted' : 'inherit',
            }}
          >
            <Stack spacing={1}>
              <Box>
                <Author
                  fullName={author}
                  timestampLabel={timestampInfoCalculator()}
                  nameSx={{fontWeight: 500}}
                />
              </Box>
              <Box>
                <Component
                  requesterName={author}
                  oldData={log.oldData}
                  newData={log.newData}
                  timestampStyle={{
                    fontSize: '12px',
                    color: 'grey.600',
                  }}
                />
              </Box>
            </Stack>
          </Box>
        </Stack>
      </Box>
    </>
  );
};
LogFeedBox.propTypes = {
  log: PropTypes.object.isRequired,
};

export default React.memo(LogFeedBox);
